import React										from 'react';

import Badge										from '../Badge';

import {useAppSelector}								from '../../../app/hooks';
import {Device}										from '../../../redux/devices/interface';
import {BadgeColor}									from '../Badge/interface';
import {DeviceStatus as int_DeviceStatus}			from '../../language/type';

import {ft_deviceIsReplaced, ft_getDeviceStatus}	from '../../functions/deviceFunction';

import LANGUAGE										from '../../language';

import './DeviceComponent.css';

interface DeviceStatusProps {
	device?: Device,
	badge?: boolean,
	forceStatus?: keyof int_DeviceStatus,
	className?: string,
	noReplaceCheck?: boolean
}

function DeviceStatus(props: DeviceStatusProps) {
	const users = useAppSelector(state => state.companyUsers.data);
	const user = useAppSelector(state => state.user.data);
	const lang = useAppSelector(state => state.settings.lang);

	const TEXTE = LANGUAGE(lang);

	if (!props.device && !props.forceStatus)
		return <></>;

	const finalStatus = props.forceStatus || ft_getDeviceStatus(props.device, users);

	if (props.badge) {
		let color: BadgeColor = 'error';

		if (finalStatus === 'active')
			color = 'success';
		if (finalStatus === 'stock' || finalStatus === 'needRepair' || finalStatus === 'repair')
			color = 'warning';

		if (props.device && (!props.device.company || props.device.company !== user?.company))
			color = 'warning';

		return (
			<Badge
				round
				size={'sm'}
				color={color}
				text={TEXTE.devices.deviceStatus[finalStatus]}
			/>
		);
	}

	return (
		<div className={'deviceStatusContainer'}>
			{!props.noReplaceCheck && ft_deviceIsReplaced(props.device) &&
				<DeviceStatus
					{...props}
					noReplaceCheck
					forceStatus={'replacement'}
				/>
			}
			<span className={`deviceStatus ${finalStatus} ${props.className}`}>{TEXTE.devices.deviceStatus[finalStatus]}</span>
		</div>
	);
}

export default DeviceStatus;
